<template>
  <ul>
    <!-- Dashboard -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightSuperHome = true"
      @mouseleave="dropRightSuperHome = false"
    >
      <NuxtLink
        to="/superadmin/home/"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Home"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <HomeSmall
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 ml-1 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Home</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightSuperHome"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/superadmin/home/"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Home</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Tiers -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightTiers = true"
      @mouseleave="dropRightTiers = false"
    >
      <div class="relative z-20 block">
        <div>
          <div
            class="block cursor-pointer truncate text-gray-200 transition duration-150 hover:text-white"
            title="Tiers"
            @click="showTiers = !showTiers"
          >
            <div
              class="relative z-10 flex items-center justify-between py-3 md:py-3"
              :class="{
                'justify-center p-0': !sideBarActive,
                'md:px-3 md:py-3 lg:px-3': sideBarActive,
              }"
            >
              <div
                class="menu-inner flex"
                :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
              >
                <SubscriptionIcon
                  class="text-sidebar-green-tertiary"
                  :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
                />
                <span
                  class="lg:sidebar-expanded:opacity-100 ml-1 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
                  :class="{ 'md:hidden lg:block': sideBarActive }"
                >Tiers</span>
              </div>
              <div
                class="hidden"
                :class="{ 'md:hidden lg:block': sideBarActive }"
              >
                <span class="text-sidebar-green-tertiary md:ml-2 lg:ml-0">
                  <ChevronDownLarge custom-style="h-5 w-5" />
                </span>
              </div>
            </div>
          </div>
          <Transition
            enter-active-class="ease-out"
            enter-from-class="transform opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in"
            leave-from-class="opacity-100"
            leave-to-class="transform opacity-0"
          >
            <div
              v-show="showTiers"
              :class="{ '!hidden': !sideBarActive, 'block': sideBarActive }"
            >
              <NuxtLink
                to="/superadmin/tiers"
                class="mb-4 mt-4 block truncate text-gray-200 transition duration-150 hover:text-white"
                title="Show All"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Show All</span>
                </div>
              </NuxtLink>
              <NuxtLink
                to="/superadmin/tiers/create"
                class="mb-4 mt-4 block truncate text-gray-200 transition duration-150 hover:text-white"
                title="Create"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Create</span>
                </div>
              </NuxtLink>
            </div>
          </Transition>
        </div>
      </div>

      <!-- Dropright Menu -->
      <div
        v-if="dropRightTiers"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col gap-y-2 bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col">
          <div class="w-full bg-sidebar-green-primary p-3 pb-0">
            <span class="text-sm font-medium text-white">Tiers</span>
            <div class="mt-3 h-0.5 w-full bg-gray-100/10" />
          </div>
          <div class="flex flex-col gap-y-4 bg-sidebar-green-primary p-4">
            <NuxtLink
              to="/superadmin/tiers"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Show All</span>
            </NuxtLink>
            <NuxtLink
              to="/superadmin/tiers/create"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Create</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </li>

    <!-- Trials -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightTrial = true"
      @mouseleave="dropRightTrial = false"
    >
      <NuxtLink
        to="/superadmin/trials/"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Trials"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <TimeIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 ml-1 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Trials</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightTrial"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/superadmin/trials/"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Trials</span>
          </NuxtLink>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SuperAdminMenu',

  data() {
    return {
      showSettings: false,
      showTiers: false,
      isCompanyAdmin: false,
      dropRightSuperHome: false,
      dropRightTiers: false,
      dropRightTrial: false,
    }
  },

  computed: {
    active() {
      return this.$store.sidebar.isActive
    },
    sideBarActive() {
      return this.$store.sidebar.responsiveActive
    },
  },

  mounted() {
    this.showSettings = false
    this.showTiers = false
    setTimeout(() => {
      const user = this.$store.auth.authenticatedUser

      if (user?.is_superuser || user?.is_zuno_engineer) return
      const cid = JSON.parse(localStorage.getItem('cid'))
      this.isCompanyAdmin = JSON.parse(localStorage.getItem('companies')).find(
        ({ id }) => id === cid,
      ).is_member_admin
    }, 2000)
  },
}
</script>

<style scoped>
.nuxt-link-active div {
  background-color: #87bda651;
  border-radius: 5px;
}

.nuxt-link-active span {
  color: #ffffff !important;
}

.nuxt-link-active .menu-inner {
  background-color: transparent;
  border-radius: 0px;
}

.nuxt-link-active .menu-child {
  padding: 8px 0px;
}
</style>
